import { REFRESH_TOKEN, REFRESH_TOKEN_DEFAULT_OPTIONS, LOGOUT } from './modules/Auth';
import { GET_PROJECT_INFO, GET_PROJECT_INFO_DEFAULT_OPTIONS } from './modules/Project';
import { GET_USER_INFO, GET_USER_INFO_DEFAULT_OPTIONS } from './modules/User';
import { GET_ALL_PREVIEW_CONFIGURATIONS, GET_ALL_PREVIEW_CONFIGURATIONS_OPTIONS, UPDATE_PREVIEW_CONFIGURATION_MUTATION, UPDATE_PREVIEW_CONFIGURATION_OPTIONS, CREATE_PREVIEW_CONFIGURATION_MUTATION, CREATE_PREVIEW_CONFIGURATION_OPTIONS } from './modules/PreviewConfiguration';
import { GET_ALL_PRODUCTS, GET_ALL_PRODUCTS_DEFAULT_OPTIONS, GET_PROJECT_TOOL_STATUS, GET_PROJECT_TOOL_STATUS_OPTIONS } from './modules/Product';
const Client = {
  REFRESH_TOKEN,
  REFRESH_TOKEN_DEFAULT_OPTIONS,
  LOGOUT,
  GET_PROJECT_INFO,
  GET_PROJECT_INFO_DEFAULT_OPTIONS,
  GET_USER_INFO,
  GET_USER_INFO_DEFAULT_OPTIONS,
  GET_ALL_PREVIEW_CONFIGURATIONS,
  GET_ALL_PREVIEW_CONFIGURATIONS_OPTIONS,
  UPDATE_PREVIEW_CONFIGURATION_MUTATION,
  UPDATE_PREVIEW_CONFIGURATION_OPTIONS,
  CREATE_PREVIEW_CONFIGURATION_MUTATION,
  CREATE_PREVIEW_CONFIGURATION_OPTIONS,
  GET_ALL_PRODUCTS,
  GET_ALL_PRODUCTS_DEFAULT_OPTIONS,
  GET_PROJECT_TOOL_STATUS,
  GET_PROJECT_TOOL_STATUS_OPTIONS
};
export default Client;